import React, { useState } from 'react';
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Spin } from 'antd';
import { useDiscernModel } from '../discernModel';

export function FinishDiscern() {
    const {
        loading
    } = useDiscernModel();
    return (
        <>
            <Spin tip="列表加载中" spinning={loading}>
                <PageHeader />
                <DataBox />
            </Spin>
        </>
    )
}

